import REST from './rest';

class ScannerAPI extends REST {
    constructor() {
        super();
        this.baseURL = `${window.config.baseurl}wp-json/wp/v2`;
    }

    /**
     * Fetch Guest Data
     */
    fetchGuest(id = 0) {
        return this._request('get', `guests/${id}`);
    }
}

const api = new ScannerAPI();

export default api;


// WEBPACK FOOTER //
// ./src/api/scanner.js